/* globals zenscroll */
import Vue from 'vue';

Vue.component('search-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        zenscroll.setup(null, 193);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },
});
